<template>
  <div class="verify-email-page">
    <HollowDotsSpinner
      :animation-duration="1000"
      :dot-size="12"
      :dots-num="3"
      :color="'#95a5a6'"
    />
    <div class="verify-email-page__message">
      {{ $t('AUTH.VERIFY_EMAIL.VERIFYING_MESSAGE') }}
    </div>
  </div>
</template>

<script>
import { Register } from '@/api/api';
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';

export default {
  name: 'VerifyEmail',
  components: { HollowDotsSpinner },
  created() {
    const { confirmation_token: confirmationToken } = this.$route.query;
    if (confirmationToken) {
      Register.verifyEmail({ confirmation_token: confirmationToken }, {})
        .then(({ body: { message, token } }) => {
          if (message) {
            this.$message.success(message);
          }

          return this.$auth
            .loginWithToken(token)
            .then(() => this.$router.replace({ name: 'register-steps' }));
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
          this.$router.replace({ name: 'login' });
        });
    } else {
      this.$router.replace({ name: 'login' });
    }
  },
};
</script>

<style lang="scss">
.verify-email-page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  &__message {
    margin-top: 1rem;
    font-size: 0.8rem;
  }
}
</style>
